import * as types from './mutation-types'
import { getModeles, getModele, enregistreModele, supprimeModele } from '../../../api/selection-modeles'
import * as constants from '../modal/modal-constants'

const getInitialState = () => {
  return {
    selectionModeles: {
      modeles: {},
      pages: 1,
      page: 1,
      loading: true,
      includeArticles: false
    },
    currentModele: {
      id: null,
      nom: '',
      selection: {
        article: {},
        famille: {}
      }
    }
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_MODELES](state, { modeles, pages }) {
    state.selectionModeles = {
      ...state.selectionModeles,
      modeles,
      pages
    }
  },
  [types.TOGGLE_MODELE_SELECTION](state, selection) {
    if (state.currentModele.selection[selection.type][selection.code] === undefined) {
      state.currentModele.selection[selection.type][selection.code] = selection
    } else {
      delete state.currentModele.selection[selection.type][selection.code]
    }
    state.currentModele.selection = {
      ...state.currentModele.selection
    }
  },
  [types.RESET_CURRENT_MODELE](state,) {
    state.currentModele = {
      id: null,
      nom: '',
      selection: {
        article: {},
        famille: {}
      }
    }
  },
  [types.SET_INCLUDE_ARTICLES](state, value) {
    state.selectionModeles.includeArticles = value
  },
  [types.SET_MODELES_LOADING]({ regroupements }, status) {
    state.selectionModeles.loading = status
  },
  [types.SET_MODELES_PAGE]({ regroupements }, page) {
    state.selectionModeles.page = page
  }
}

const actions = {
  async setModeles({ state, commit }) {
    commit(types.SET_MODELES_LOADING, true)
    const modeles = await getModeles({ page: state.selectionModeles.page })
    commit(types.SET_MODELES, modeles)
    commit(types.SET_MODELES_LOADING, false)
  },
  setModelesPage({ commit, dispatch }, page) {
    commit(types.SET_MODELES_LOADING, true)
    commit(types.SET_MODELES_PAGE, page)
    dispatch('setModeles')
  },
  async openEditorSelectionModele({ dispatch }, id = null) {
    await dispatch('getPlanVente')
    if (id !== null) {
      state.currentModele = await getModele(id)
    } else {
      await dispatch('resetCurrentModele')
    }
    dispatch('openModal', { type: constants.SELECTION_MODELE_EDITOR_MODAL })
  },
  clickPlanVenteSelectionModele({ state, commit, dispatch }, selection) {
    commit(types.TOGGLE_MODELE_SELECTION, selection)
  },
  async validationModele({ dispatch }) {
    await enregistreModele(state.currentModele)
    dispatch('setModeles')
  },
  async resetCurrentModele({ commit }) {
    commit(types.RESET_CURRENT_MODELE)
  },
  async suppressionModele({ commit, dispatch }) {
    await supprimeModele(state.currentModele.id)
    dispatch('setModeles')
  },
  async setIncludeArticles({ commit }, value) {
    commit(types.SET_INCLUDE_ARTICLES, value.target.checked)
  }
}

const getters = {
  modeles: state => state.selectionModeles.modeles,
  currentModele: state => state.currentModele,
  modelesPages: state => state.selectionModeles.pages,
  modelesPage: state => state.selectionModeles.page,
  includeArticles: state => state.selectionModeles.includeArticles
}

export default { state, mutations, actions, getters }
